"use client";

import React from "react";
import styled from "styled-components";

import { FavoriteTrackingEventsContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/Favorite/__internal__/FavoriteTrackingEventsContext";
import { FavoriteTrackingEventsContextProvider } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/Favorite/__internal__/FavoriteTrackingEventsContextProvider";
import { FavoriteProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/Favorite/FavoriteProps";
import {
  SaveToBoard,
  SaveToBoardContext,
  SaveToBoardProvider,
} from "@faire/retailer/features/RetailerBoards/Components/SaveToBoard";

const FavoriteBase = ({
  data: { productToken, hide, bestImage, boardTokens, brandToken },
}: {
  data: FavoriteProps;
}) => {
  const saveToBoardContext = React.useContext(SaveToBoardContext);

  const {
    recordHeartClickedEvent,
    recordSaveToBoardSubmitEvent,
    recordRemoveFromBoardSubmitEvent,
  } = React.useContext(FavoriteTrackingEventsContext);

  // There used to be a canSaveToBoard to control whether we should render this button
  // but it's truthy in discovery tiles, so we don't need to handle it here.
  if (hide) {
    return;
  }

  return (
    <StyledSaveToBoardContainer>
      <SaveToBoardProvider
        value={{
          trackOrigin: saveToBoardContext.trackOrigin ?? "brand",
        }}
      >
        <SaveToBoard
          data-test-id="favorite-button"
          key={`${productToken}-favorite`}
          productToken={productToken}
          productImage={bestImage}
          boardTokens={boardTokens}
          brandToken={brandToken}
          onHeartClicked={recordHeartClickedEvent}
          onSaveToBoard={recordSaveToBoardSubmitEvent}
          onRemoveFromBoard={recordRemoveFromBoardSubmitEvent}
        />
      </SaveToBoardProvider>
    </StyledSaveToBoardContainer>
  );
};

export const Favorite = ({ data }: { data: FavoriteProps }) => {
  return (
    <FavoriteTrackingEventsContextProvider data={data}>
      <FavoriteBase data={data} />
    </FavoriteTrackingEventsContextProvider>
  );
};

const StyledSaveToBoardContainer = styled.div`
  position: absolute;
  right: 4px;
  z-index: 3;
  top: 4px;
`;
